"use client";
import { useMediaQuery } from "../use-media-query/use-media-query.mjs";
//#region packages/@mantine/hooks/src/use-color-scheme/use-color-scheme.ts
function useColorScheme(initialValue, options) {
	return useMediaQuery("(prefers-color-scheme: dark)", initialValue === "dark", options) ? "dark" : "light";
}
//#endregion
export { useColorScheme };

//# sourceMappingURL=use-color-scheme.mjs.map